import cnames from 'classnames'

const PageSubtitle = ({ className, text }) => {
  const defaultClasses = cnames('mb-2 fw-bold', className)

  return <h5 className={defaultClasses}>{text}</h5>
}

export default PageSubtitle
